import { CheckOutlined, SyncOutlined } from '@ant-design/icons';
import { Avatar, Button } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function ConnectedScreen({ avatarUrl, phone, isRegeneratingQr, onReloadQr }) {
	return (
		<div className="connected-screen">
			<header className="onboarding-screen-header">
				<h1>
					<FormattedMessage id="connected_title" />
				</h1>
				<p>
					<FormattedMessage id="connected_subtitle" />
				</p>
			</header>
			<Avatar className="connected-avatar" size={205} src={avatarUrl || undefined} icon="user" />
			<div className="connected-label">WhatsApp</div>
			{phone ? (
				<div className="connected-phone">
					<CheckOutlined />
					{String(phone).startsWith('+') ? phone : `+${phone}`}
				</div>
			) : null}
			{onReloadQr ? (
				<Button
					type="link"
					onClick={onReloadQr}
					disabled={isRegeneratingQr}
					className="qr-regenerate-button connected-regenerate"
				>
					<SyncOutlined spin={isRegeneratingQr} />
					<FormattedMessage id="qr_regenerate" />
				</Button>
			) : null}
		</div>
	);
}
